import { GetErrorText } from '../text/error-code';

let toastElementRef = null;
export function SetRef(el) {
    toastElementRef = el;
}

export function ShowError(err) {
    console.log('err', err);
    if (toastElementRef) {
        let title = 'Error';
        let message = '';
        if (err) {
            if (err.code) {
                title = 'Error ' + err.code;
                message = GetErrorText(err.code);
            }
            if (!message && err.message) {
                message = err.message;
            }
        }
        toastElementRef.show({ severity: 'error', summary: title, detail: message, life: 5000 });
    }
}

export function ShowInfo(severity, title, message) {
    if (toastElementRef) {
        toastElementRef.show({ severity: severity, summary: title, detail: message, life: 5000 });
    }
}

/*
success
info
warn
error
*/
